module.exports = __webpack_public_path__ + "img/flower.313e9126.png";